// The account keeps its ISO currency; presentation uses the familiar symbol.
export function formatMoney(value, currency = 'USD', options = {}) {
  const { signed = false, signZero = false, locale = 'en-GB', ...numberOptions } = options;
  const prefix = signed ? value < 0 ? '−' : value > 0 || signZero ? '+' : '' : '';
  return prefix + new Intl.NumberFormat(locale, {
    style: 'currency', currency, currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 0, ...numberOptions,
  }).format(signed ? Math.abs(value) : value);
}
